import React from "react";

const ITEMS = [
    "Sites web artisans",
    "SEO local",
    "Refonte",
    "Identité visuelle",
    "Fiche Google",
    "Devis en ligne",
    "Framer",
    "Webflow",
    "Suivi performance",
];

export default function Marquee() {
    const loop = [...ITEMS, ...ITEMS];
    return (
        <section
            aria-label="Nos expertises"
            className="relative overflow-hidden bg-[#1A2F6E] py-10 md:py-14 border-y border-white/5"
            data-testid="marquee-section"
        >
            <div className="flex animate-marquee whitespace-nowrap will-change-transform" aria-hidden>
                {loop.map((item, i) => (
                    <div
                        key={i}
                        className="flex items-center gap-8 md:gap-12 px-6 md:px-10 font-display font-bold uppercase tracking-tighter text-4xl md:text-6xl"
                    >
                        <span className="text-white/90">{item}</span>
                        <span className="text-[#2B7BE4]">•</span>
                    </div>
                ))}
            </div>
        </section>
    );
}
